// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PhI7","option":"styles_option__3FSWn","selected":"styles_selected__1qa46"};